App.SearchFieldComponent = Em.Component.extend [
  Em.I18n.TranslateableAttributes,
  Em.I18n.TranslateableProperties
]...,
  classNames: [ 'search-field' ]

  classNameBindings: [ 'emptyButtonActive' ]

  emptyButtonActive: (->
    value = @get('value')
    _.isString(value) and value.length > 0
  ).property('value')


  actions:
    clear: ->
      @set('value', '')
      false
